import "bootstrap-vue/dist/bootstrap-vue.css";
import store from "./store";
import popularDestinationDetail from "./PopularDestinationDetail";
import VueI18n from "vue-i18n";
import { i18nFactory } from "@/plugins/i18n.plugin";
import { ApiClientPlugin } from "@/plugins/api.plugin";
import { ApiClient } from "@/api";

document.addEventListener("DOMContentLoaded", function () {
  window.mainVue.use(VueI18n);
  window.mainVue.use(ApiClientPlugin, { ApiClient, store });

  let stateNew = Object.assign({}, store.state);
  stateNew.destination = window.transferState.get("destination");
  store.replaceState(stateNew);
  new window.mainVue({
    store: store,
    render: (h) => h(popularDestinationDetail),
    i18n: i18nFactory(),
  }).$mount("#popularDestinationDetail");
});
